import { ORG_TYPE_FILTER_OPTIONS } from '../../lib/orgTypes';

interface OrgTypeFilterProps {
  selected: string[];
  onToggle: (value: string) => void;
  onClear: () => void;
}

export const OrgTypeFilter = ({ selected, onToggle, onClear }: OrgTypeFilterProps) => (
  <div>
    <div className="flex items-center justify-between mb-2">
      <span id="org-type-filter-label" className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">
        Type
      </span>
      {selected.length > 0 && (
        <button
          type="button"
          onClick={onClear}
          className="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100"
        >
          Clear
        </button>
      )}
    </div>
    <div className="flex flex-wrap gap-1.5" role="group" aria-labelledby="org-type-filter-label">
      {ORG_TYPE_FILTER_OPTIONS.map((opt) => {
        const isOn = selected.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onToggle(opt.value)}
            aria-pressed={isOn}
            className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
              isOn
                ? 'bg-purple-600 dark:bg-purple-500 border-purple-600 dark:border-purple-500 text-white'
                : 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:border-purple-400 dark:hover:border-purple-500'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  </div>
);
